import { SxProps, TextFieldProps, Theme, useTheme } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { FC } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { DefaultLabelSx, DefaultSx, StyledTextField } from './GenericTextField.styles';

type GenericTextFieldProps = TextFieldProps & {
  label: string;
  sx?: SxProps<Theme>;
  isDate?: boolean;
};

const GenericTextField: FC<GenericTextFieldProps> = ({ label, sx, isDate, ...rest }) => {
  const theme = useTheme();
  const mergedSx: SxProps<Theme> = { ...DefaultSx, ...(sx as object) };

  if (isDate) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={rest.value ? dayjs(rest.value as string) : null}
          onChange={(newValue: Dayjs | null) => {
            if (rest.onChange) {
              const syntheticEvent = {
                target: { value: newValue ? newValue.format('YYYY-MM-DD') : '' }
              } as React.ChangeEvent<HTMLInputElement>;
              rest.onChange(syntheticEvent);
            }
          }}
          disabled={rest.disabled}
          maxDate={dayjs()}
          views={['month', 'year', 'day']}
          slotProps={{
            yearButton: {
              sx: {
                color: 'text.primary'
              }
            },
            monthButton: {
              sx: {
                color: 'text.primary'
              }
            },
            textField: {
              required: rest.required,
              fullWidth: true,
              variant: 'outlined',
              sx: mergedSx,
              InputLabelProps: { sx: DefaultLabelSx(theme) },
              InputProps: {
                sx: {
                  borderRadius: '10px',
                  '& fieldset': {
                    borderRadius: '10px'
                  },
                  backgroundColor: '#fff'
                }
              }
            }
          }}
        />
      </LocalizationProvider>
    );
  }

  return <StyledTextField fullWidth label={label} variant="outlined" sx={mergedSx} {...rest} />;
};
export default GenericTextField;
